import { createAsyncThunk } from "@reduxjs/toolkit";
import setsService from "../../../api/services/sets";

export const getAllSets = createAsyncThunk(
  "sets/get-all-sets",
  async (params = {}, { rejectWithValue }) => {
    try {
      return await setsService.getAllSets(params);
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const getFeaturedSets = createAsyncThunk(
  "sets/get-featured-sets",
  async (params = {}, { rejectWithValue }) => {
    try {
      return await setsService.getFeaturedSets(params);
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const getPublicSetById = createAsyncThunk(
  "sets/get-public-set-by-id",
  async (id, { rejectWithValue }) => {
    try {
      return await setsService.getPublicSetById(id);
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const getSetById = createAsyncThunk(
  "sets/get-set-by-id",
  async (id, { rejectWithValue }) => {
    try {
      return await setsService.getSetById(id);
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const getMySetById = createAsyncThunk(
  "sets/get-my-set-by-id",
  async (id, { rejectWithValue }) => {
    try {
      return await setsService.getMySetById(id);
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const createSet = createAsyncThunk(
  "sets/create-set",
  async (setData, { rejectWithValue }) => {
    try {
      return await setsService.createSet(setData);
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const updateSet = createAsyncThunk(
  "sets/update-set",
  async ({ id, formData }, { rejectWithValue }) => {
    try {
      return await setsService.updateSet(id, formData);
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const deleteSet = createAsyncThunk(
  "sets/delete-set",
  async (id, { rejectWithValue }) => {
    try {
      return await setsService.deleteSet(id);
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const getSetsStatistics = createAsyncThunk(
  "sets/get-sets-statistics",
  async (_, { rejectWithValue }) => {
    try {
      return await setsService.getSetsStatistics();
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const exportSets = createAsyncThunk(
  "sets/export-sets",
  async (_, { rejectWithValue }) => {
    try {
      return await setsService.exportSets();
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const importSets = createAsyncThunk(
  "sets/import-sets",
  async (file, { rejectWithValue }) => {
    try {
      return await setsService.importSets(file);
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);
